import React from "react";

const RewarWeb = () => {
  return (
    <div className="col col-10 my-12">
      <div style={{ height: "100%" }}>
        <div className="desktop_referral_card hidden-sm-and-down afrLoginContainer v-card v-sheet theme--light">
          <div className="afterLogin">
            <div>
              <div
                className="row px-4 no-gutters"
                style={{ position: "relative" }}
              >
                <div className="row no-gutters">
                  <div className="pa-0 col col-12">
                    <div className="v-image v-responsive newReferralBanner-desktop theme--light">
                      <div
                        className="v-responsive__sizer"
                        style={{ "padding-bottom": "18.3908%" }}
                      />
                      <div
                        className="v-image__image v-image__image--cover"
                        style={{
                          "background-image":
                            'url("/assets/new/reward_banner_desktop.jpg")',
                          "background-position": "center center",
                        }}
                      />
                      <div className="v-responsive__content">
                        <div className="rewardStoreBannerText">
                          <div className="row no-gutters">
                            <div className="pa-0 col col-7" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/**/}
          <div className="v-card__text pa-0 pt-1">
            <div style={{ "min-height": "440px" }}>
              <div className="row no-gutters">
                <div className="col col-12">
                  <div className="referral-tier">
                    <div className="hidden-sm-and-down">
                      <div>
                        <div className="container Product-Container py-5">
                          <div
                            className="row"
                            style={{
                              "max-width": "100% !important",
                              gap: "10px 0px",
                            }}
                          >
                            <div
                              className="col"
                              style={{
                                width: "20%",
                                "max-width": "20%",
                                padding: "5px 8px",
                              }}
                            >
                              <div className="product-container v-card v-sheet theme--light">
                                <div
                                  className="v-image v-responsive theme--light"
                                  style={{ height: "180px" }}
                                >
                                  <div
                                    className="v-responsive__sizer"
                                    style={{ "padding-bottom": "100%" }}
                                  />
                                  <div
                                    className="v-image__image v-image__image--contain"
                                    style={{
                                      "background-image":
                                        'url("/assets/new/68eb99529c540.webp")',
                                      "background-position": "center center",
                                    }}
                                  />
                                  <div
                                    className="v-responsive__content"
                                    style={{ width: "1080px" }}
                                  >
                                    <div
                                      className="v-image v-responsive hot-icon theme--light"
                                      style={{ height: "25px", width: "25px" }}
                                    >
                                      <div
                                        className="v-responsive__sizer"
                                        style={{ "padding-bottom": "100%" }}
                                      />
                                      <div
                                        className="v-image__image v-image__image--cover"
                                        style={{
                                          "background-image":
                                            'url("/assets/new/game-icon-hot.svg")',
                                          "background-position":
                                            "center center",
                                        }}
                                      />
                                      <div
                                        className="v-responsive__content"
                                        style={{ width: "35px" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="v-card__title">
                                  <span className="px-1 points_required">
                                    6,000
                                  </span>
                                </div>
                                <div className="v-card__subtitle subtitle_class">
                                  <span className="productName">
                                    Mobile Recharge ৳3000
                                  </span>
                                </div>
                                <div className="v-card__actions justify-center action_class">
                                  <button
                                    type="button"
                                    className="claimNow v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                                    style={{
                                      "background-color": "rgb(198, 255, 0)",
                                      "border-color": "rgb(198, 255, 0)",
                                    }}
                                  >
                                    <span className="v-btn__content">
                                      Claim Now
                                    </span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row hidden-md-and-up justify-center">
                      <div style={{ "max-width": "100%" }}>
                        <div className="detailContainer_mobile">
                          <div className="container Product-Container">
                            <div
                              className="row"
                              style={{
                                "max-width": "100%",
                                "background-color": "rgb(239, 240, 245)",
                                margin: "0px",
                              }}
                            >
                              <div
                                className="col col-6"
                                style={{ padding: "6px" }}
                              >
                                <div className="product-container v-card v-sheet theme--light">
                                  <div
                                    className="v-image v-responsive theme--light"
                                    style={{ height: "200px" }}
                                  >
                                    <div
                                      className="v-image__image v-image__image--preload v-image__image--contain"
                                      style={{
                                        "background-position": "center center",
                                      }}
                                    />
                                    <div className="v-responsive__content">
                                      <div
                                        className="v-image v-responsive hot-icon theme--light"
                                        style={{
                                          height: "25px",
                                          width: "25px",
                                        }}
                                      >
                                        <div
                                          className="v-image__image v-image__image--preload v-image__image--cover"
                                          style={{
                                            "background-position":
                                              "center center",
                                          }}
                                        />
                                        <div className="v-responsive__content" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="v-card__title">
                                    <span className="px-1 points_required">
                                      6000
                                    </span>
                                  </div>
                                  <div className="v-card__subtitle subtitle_class">
                                    <span className="px-1">
                                      Mobile Recharge ৳3000
                                    </span>
                                  </div>
                                  <div className="v-card__actions justify-center action_class">
                                    <button
                                      type="button"
                                      className="claimNow v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                                      style={{
                                        "background-color": "rgb(198, 255, 0)",
                                        "border-color": "rgb(198, 255, 0)",
                                      }}
                                    >
                                      <span className="v-btn__content">
                                        Claim Now
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="col col-6"
                                style={{ padding: "6px" }}
                              >
                                <div className="product-container v-card v-sheet theme--light">
                                  <div
                                    className="v-image v-responsive theme--light"
                                    style={{ height: "200px" }}
                                  >
                                    <div
                                      className="v-image__image v-image__image--preload v-image__image--contain"
                                      style={{
                                        "background-position": "center center",
                                      }}
                                    />
                                    <div className="v-responsive__content">
                                      <div
                                        className="v-image v-responsive hot-icon theme--light"
                                        style={{
                                          height: "25px",
                                          width: "25px",
                                        }}
                                      >
                                        <div
                                          className="v-image__image v-image__image--preload v-image__image--cover"
                                          style={{
                                            "background-position":
                                              "center center",
                                          }}
                                        />
                                        <div className="v-responsive__content" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="v-card__title">
                                    <span className="px-1 points_required">
                                      2000
                                    </span>
                                  </div>
                                  <div className="v-card__subtitle subtitle_class">
                                    <span className="px-1">
                                      Mobile Recharge ৳1000
                                    </span>
                                  </div>
                                  <div className="v-card__actions justify-center action_class">
                                    <button
                                      type="button"
                                      className="claimNow v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                                      style={{
                                        "background-color": "rgb(198, 255, 0)",
                                        "border-color": "rgb(198, 255, 0)",
                                      }}
                                    >
                                      <span className="v-btn__content">
                                        Claim Now
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="col col-6"
                                style={{ padding: "6px" }}
                              >
                                <div className="product-container v-card v-sheet theme--light">
                                  <div
                                    className="v-image v-responsive theme--light"
                                    style={{ height: "200px" }}
                                  >
                                    <div
                                      className="v-image__image v-image__image--preload v-image__image--contain"
                                      style={{
                                        "background-position": "center center",
                                      }}
                                    />
                                    <div className="v-responsive__content">
                                      <div
                                        className="v-image v-responsive hot-icon theme--light"
                                        style={{
                                          height: "25px",
                                          width: "25px",
                                        }}
                                      >
                                        <div
                                          className="v-image__image v-image__image--preload v-image__image--cover"
                                          style={{
                                            "background-position":
                                              "center center",
                                          }}
                                        />
                                        <div className="v-responsive__content" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="v-card__title">
                                    <span className="px-1 points_required">
                                      1000
                                    </span>
                                  </div>
                                  <div className="v-card__subtitle subtitle_class">
                                    <span className="px-1">
                                      Mobile Recharge ৳500
                                    </span>
                                  </div>
                                  <div className="v-card__actions justify-center action_class">
                                    <button
                                      type="button"
                                      className="claimNow v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                                      style={{
                                        "background-color": "rgb(198, 255, 0)",
                                        "border-color": "rgb(198, 255, 0)",
                                      }}
                                    >
                                      <span className="v-btn__content">
                                        Claim Now
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="col col-6"
                                style={{ padding: "6px" }}
                              >
                                <div className="product-container v-card v-sheet theme--light">
                                  <div
                                    className="v-image v-responsive theme--light"
                                    style={{ height: "200px" }}
                                  >
                                    <div
                                      className="v-image__image v-image__image--preload v-image__image--contain"
                                      style={{
                                        "background-position": "center center",
                                      }}
                                    />
                                    <div className="v-responsive__content">
                                      <div
                                        className="v-image v-responsive hot-icon theme--light"
                                        style={{
                                          height: "25px",
                                          width: "25px",
                                        }}
                                      >
                                        <div
                                          className="v-image__image v-image__image--preload v-image__image--cover"
                                          style={{
                                            "background-position":
                                              "center center",
                                          }}
                                        />
                                        <div className="v-responsive__content" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="v-card__title">
                                    <span className="px-1 points_required">
                                      6500
                                    </span>
                                  </div>
                                  <div className="v-card__subtitle subtitle_class">
                                    <span className="px-1">100 Free Spin</span>
                                  </div>
                                  <div className="v-card__actions justify-center action_class">
                                    <button
                                      type="button"
                                      className="claimNow v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                                      style={{
                                        "background-color": "rgb(198, 255, 0)",
                                        "border-color": "rgb(198, 255, 0)",
                                      }}
                                    >
                                      <span className="v-btn__content">
                                        Claim Now
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="col col-6"
                                style={{ padding: "6px" }}
                              >
                                <div className="product-container v-card v-sheet theme--light">
                                  <div
                                    className="v-image v-responsive theme--light"
                                    style={{ height: "200px" }}
                                  >
                                    <div
                                      className="v-image__image v-image__image--preload v-image__image--contain"
                                      style={{
                                        "background-position": "center center",
                                      }}
                                    />
                                    <div className="v-responsive__content">
                                      <div
                                        className="v-image v-responsive hot-icon theme--light"
                                        style={{
                                          height: "25px",
                                          width: "25px",
                                        }}
                                      >
                                        <div
                                          className="v-image__image v-image__image--preload v-image__image--cover"
                                          style={{
                                            "background-position":
                                              "center center",
                                          }}
                                        />
                                        <div className="v-responsive__content" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="v-card__title">
                                    <span className="px-1 points_required">
                                      3500
                                    </span>
                                  </div>
                                  <div className="v-card__subtitle subtitle_class">
                                    <span className="px-1">
                                      50 Free Spin (50 BDT per spin)
                                    </span>
                                  </div>
                                  <div className="v-card__actions justify-center action_class">
                                    <button
                                      type="button"
                                      className="claimNow v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                                      style={{
                                        "background-color": "rgb(198, 255, 0)",
                                        "border-color": "rgb(198, 255, 0)",
                                      }}
                                    >
                                      <span className="v-btn__content">
                                        Claim Now
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="col col-6"
                                style={{ padding: "6px" }}
                              >
                                <div className="product-container v-card v-sheet theme--light">
                                  <div
                                    className="v-image v-responsive theme--light"
                                    style={{ height: "200px" }}
                                  >
                                    <div
                                      className="v-image__image v-image__image--preload v-image__image--contain"
                                      style={{
                                        "background-position": "center center",
                                      }}
                                    />
                                    <div className="v-responsive__content">
                                      <div
                                        className="v-image v-responsive hot-icon theme--light"
                                        style={{
                                          height: "25px",
                                          width: "25px",
                                        }}
                                      >
                                        <div
                                          className="v-image__image v-image__image--preload v-image__image--cover"
                                          style={{
                                            "background-position":
                                              "center center",
                                          }}
                                        />
                                        <div className="v-responsive__content" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="v-card__title">
                                    <span className="px-1 points_required">
                                      2000
                                    </span>
                                  </div>
                                  <div className="v-card__subtitle subtitle_class">
                                    <span className="px-1">
                                      30 Free Spin (50 BDT per spin)
                                    </span>
                                  </div>
                                  <div className="v-card__actions justify-center action_class">
                                    <button
                                      type="button"
                                      className="claimNow v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                                      style={{
                                        "background-color": "rgb(198, 255, 0)",
                                        "border-color": "rgb(198, 255, 0)",
                                      }}
                                    >
                                      <span className="v-btn__content">
                                        Claim Now
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="col col-6"
                                style={{ padding: "6px" }}
                              >
                                <div className="product-container v-card v-sheet theme--light">
                                  <div
                                    className="v-image v-responsive theme--light"
                                    style={{ height: "200px" }}
                                  >
                                    <div
                                      className="v-image__image v-image__image--preload v-image__image--contain"
                                      style={{
                                        "background-position": "center center",
                                      }}
                                    />
                                    <div className="v-responsive__content">
                                      <div
                                        className="v-image v-responsive hot-icon theme--light"
                                        style={{
                                          height: "25px",
                                          width: "25px",
                                        }}
                                      >
                                        <div
                                          className="v-image__image v-image__image--preload v-image__image--cover"
                                          style={{
                                            "background-position":
                                              "center center",
                                          }}
                                        />
                                        <div className="v-responsive__content" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="v-card__title">
                                    <span className="px-1 points_required">
                                      94640
                                    </span>
                                  </div>
                                  <div className="v-card__subtitle subtitle_class">
                                    <span className="px-1">
                                      EVERCROSS Electric Scooter
                                    </span>
                                  </div>
                                  <div className="v-card__actions justify-center action_class">
                                    <button
                                      type="button"
                                      className="claimNow v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                                      style={{
                                        "background-color": "rgb(198, 255, 0)",
                                        "border-color": "rgb(198, 255, 0)",
                                      }}
                                    >
                                      <span className="v-btn__content">
                                        Claim Now
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="col col-6"
                                style={{ padding: "6px" }}
                              >
                                <div className="product-container v-card v-sheet theme--light">
                                  <div
                                    className="v-image v-responsive theme--light"
                                    style={{ height: "200px" }}
                                  >
                                    <div
                                      className="v-image__image v-image__image--preload v-image__image--contain"
                                      style={{
                                        "background-position": "center center",
                                      }}
                                    />
                                    <div className="v-responsive__content">
                                      <div
                                        className="v-image v-responsive hot-icon theme--light"
                                        style={{
                                          height: "25px",
                                          width: "25px",
                                        }}
                                      >
                                        <div
                                          className="v-image__image v-image__image--preload v-image__image--cover"
                                          style={{
                                            "background-position":
                                              "center center",
                                          }}
                                        />
                                        <div className="v-responsive__content" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="v-card__title">
                                    <span className="px-1 points_required">
                                      84998
                                    </span>
                                  </div>
                                  <div className="v-card__subtitle subtitle_class">
                                    <span className="px-1">
                                      Lenovo IdeaPad 3 i3-1215U
                                    </span>
                                  </div>
                                  <div className="v-card__actions justify-center action_class">
                                    <button
                                      type="button"
                                      className="claimNow v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                                      style={{
                                        "background-color": "rgb(198, 255, 0)",
                                        "border-color": "rgb(198, 255, 0)",
                                      }}
                                    >
                                      <span className="v-btn__content">
                                        Claim Now
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="col col-6"
                                style={{ padding: "6px" }}
                              >
                                <div className="product-container v-card v-sheet theme--light">
                                  <div
                                    className="v-image v-responsive theme--light"
                                    style={{ height: "200px" }}
                                  >
                                    <div
                                      className="v-image__image v-image__image--preload v-image__image--contain"
                                      style={{
                                        "background-position": "center center",
                                      }}
                                    />
                                    <div className="v-responsive__content">
                                      <div
                                        className="v-image v-responsive hot-icon theme--light"
                                        style={{
                                          height: "25px",
                                          width: "25px",
                                        }}
                                      >
                                        <div
                                          className="v-image__image v-image__image--preload v-image__image--cover"
                                          style={{
                                            "background-position":
                                              "center center",
                                          }}
                                        />
                                        <div className="v-responsive__content" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="v-card__title">
                                    <span className="px-1 points_required">
                                      239800
                                    </span>
                                  </div>
                                  <div className="v-card__subtitle subtitle_class">
                                    <span className="px-1">
                                      Hisense 566 L Side by Side Refrigerator-
                                      RS67W4NV
                                    </span>
                                  </div>
                                  <div className="v-card__actions justify-center action_class">
                                    <button
                                      type="button"
                                      className="claimNow v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                                      style={{
                                        "background-color": "rgb(198, 255, 0)",
                                        "border-color": "rgb(198, 255, 0)",
                                      }}
                                    >
                                      <span className="v-btn__content">
                                        Claim Now
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="col col-6"
                                style={{ padding: "6px" }}
                              >
                                <div className="product-container v-card v-sheet theme--light">
                                  <div
                                    className="v-image v-responsive theme--light"
                                    style={{ height: "200px" }}
                                  >
                                    <div
                                      className="v-image__image v-image__image--preload v-image__image--contain"
                                      style={{
                                        "background-position": "center center",
                                      }}
                                    />
                                    <div className="v-responsive__content">
                                      <div
                                        className="v-image v-responsive hot-icon theme--light"
                                        style={{
                                          height: "25px",
                                          width: "25px",
                                        }}
                                      >
                                        <div
                                          className="v-image__image v-image__image--preload v-image__image--cover"
                                          style={{
                                            "background-position":
                                              "center center",
                                          }}
                                        />
                                        <div className="v-responsive__content" />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="v-card__title">
                                    <span className="px-1 points_required">
                                      289800
                                    </span>
                                  </div>
                                  <div className="v-card__subtitle subtitle_class">
                                    <span className="px-1">
                                      Haier Side-by-Side Refrigerator
                                      Model-HRF-622ICG
                                    </span>
                                  </div>
                                  <div className="v-card__actions justify-center action_class">
                                    <button
                                      type="button"
                                      className="claimNow v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                                      style={{
                                        "background-color": "rgb(198, 255, 0)",
                                        "border-color": "rgb(198, 255, 0)",
                                      }}
                                    >
                                      <span className="v-btn__content">
                                        Claim Now
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="text-center mb-6">
                        <nav
                          role="navigation"
                          aria-label="Pagination Navigation"
                          className="game_pagination"
                        >
                          <ul className="v-pagination theme--light">
                            <li>
                              <button
                                disabled="disabled"
                                type="button"
                                aria-label="Previous page"
                                className="v-pagination__navigation v-pagination__navigation--disabled"
                              >
                                <i
                                  aria-hidden="true"
                                  className="v-icon notranslate mdi mdi-chevron-left theme--light"
                                />
                              </button>
                            </li>
                            <li>
                              <button
                                type="button"
                                aria-current="true"
                                aria-label="Current Page, Page 1"
                                className="v-pagination__item v-pagination__item--active primary"
                              >
                                1
                              </button>
                            </li>
                            <li>
                              <button
                                type="button"
                                aria-label="Goto Page 2"
                                className="v-pagination__item"
                              >
                                2
                              </button>
                            </li>
                            <li>
                              <button
                                type="button"
                                aria-label="Goto Page 3"
                                className="v-pagination__item"
                              >
                                3
                              </button>
                            </li>
                            <li>
                              <button
                                type="button"
                                aria-label="Goto Page 4"
                                className="v-pagination__item"
                              >
                                4
                              </button>
                            </li>
                            <li>
                              <button
                                type="button"
                                aria-label="Next page"
                                className="v-pagination__navigation"
                              >
                                <i
                                  aria-hidden="true"
                                  className="v-icon notranslate mdi mdi-chevron-right theme--light"
                                />
                              </button>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="justify-space-around hidden-md-and-up v-card v-sheet theme--light elevation-0">
          <div
            className="row d-flex justify-space-between no-gutters"
            style={{ "background-color": "rgb(243, 245, 246)" }}
          >
            <div className="pa-0 d-flex justify-center align-center col col-4">
              <span className="rewardText">Rewards</span>
            </div>
            <div className="pa-0 d-flex justify-end col col-3">
              <div
                className="v-image v-responsive theme--light"
                style={{ height: "100px" }}
              >
                <div
                  className="v-image__image v-image__image--preload v-image__image--cover"
                  style={{ "background-position": "center center" }}
                />
                <div className="v-responsive__content" />
              </div>
            </div>
          </div>
          <div className="row pt-3 no-gutters">
            <div className="row mobileRewardContainer pa-3 ma-3 no-gutters">
              <div className="pa-0 col col-12">
                <div className="row card-row justify-space-between no-gutters">
                  <div className="py-2 px-0 d-flex col col-6">
                    My reward coins
                  </div>
                  <div className="pa-0 d-flex col col-6">
                    <div className="py-2 px-0 d-flex justify-end goRewardHistory col col-12">
                      <span>Reward History &gt;</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="pa-0 col col-12">
                <div className="row card-row justify-space-between no-gutters">
                  <div className="pa-0 d-flex rewardCoinsBorderMobile col col-7">
                    <div className="py-2 px-0 rewardCoinsContainerMobile col col-3">
                      <img
                        src="/static/svg/rewardCoins.svg"
                        width={30}
                        height={30}
                      />
                    </div>
                    <div className="py-2 px-2 rewardCoinsTextContainerMobile black--text col col-9">
                      <span>0</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-left col col-12">
              <div className="scrollable-container pa-3 ma-3">
                <a
                  href="/reward/rewardStore"
                  className="reward-tab mr-2 inactive-btn v-btn--active v-btn v-btn--plain v-btn--router theme--light v-size--default active-btn"
                >
                  <span className="v-btn__content">
                    <div
                      className="v-image v-responsive theme--light"
                      style={{ height: "20px", width: "20px" }}
                    >
                      <div
                        className="v-image__image v-image__image--preload v-image__image--cover"
                        style={{ "background-position": "center center" }}
                      />
                      <div className="v-responsive__content" />
                    </div>
                    <span className="pl-2">Reward Store</span>
                  </span>
                </a>
                <button
                  type="button"
                  className="reward-tab mr-2 inactive-btn v-btn v-btn--plain theme--light v-size--default"
                >
                  <span className="v-btn__content">
                    <div
                      className="v-image v-responsive theme--light"
                      style={{ height: "20px", width: "20px" }}
                    >
                      <div
                        className="v-image__image v-image__image--preload v-image__image--cover"
                        style={{ "background-position": "center center" }}
                      />
                      <div className="v-responsive__content" />
                    </div>
                    <span className="pl-2">Check-In</span>
                  </span>
                </button>
                <a
                  href="/mluckywheel"
                  className="reward-tab mr-2 inactive-btn v-btn v-btn--plain v-btn--router theme--light v-size--default inactive-btn"
                >
                  <span className="v-btn__content">
                    <div
                      className="v-image v-responsive theme--light"
                      style={{ height: "20px", width: "20px" }}
                    >
                      <div
                        className="v-image__image v-image__image--preload v-image__image--cover"
                        style={{ "background-position": "center center" }}
                      />
                      <div className="v-responsive__content" />
                    </div>
                    <span className="pl-2">Wheel Of Fortune</span>
                  </span>
                </a>
              </div>
            </div>
          </div>
          {/**/}
        </div>
      </div>
    </div>
  );
};

export default RewarWeb;
